module.exports = __webpack_public_path__ + "assets/05fd1c69999fb0ddfced72606087cf62.svg";